import React, { useState } from 'react';
import { Link } from 'react-router-dom';
const wpUrl = process.env.REACT_APP_WP_URL
console.log(wpUrl)
const serviceDetails = {

  servicecard: [
    {
      question: "Partnership Opportunities",
      answer:
        "Join our 300+ partner network, including Ultra Miami and Caesars Palace.",
    },
    {
      question: "Event Exposure",
      answer:
        "Reach 1M+ contacts through our app and marketing channels.",
    },
    {
      question: "Expert Support",
      answer:
        "20+ years of event marketing expertise at your service.",
    },
  ],
  
};

const schema = {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  mainEntity: {
    "@type": "Organization",
    name: "RSVPPASS",
    url: "https://rsvppass.com",
    logo: "https://rsvppass.com/logo.png",
    contactPoint: {
      "@type": "ContactPoint",
      email: "info@rsvppass.com",
      telephone: "+1-619-555-1234",
      contactType: "Customer Service",
      areaServed: "US",
      availableLanguage: ["English"]
    },
    address: {
      "@type": "PostalAddress",
      streetAddress: "123 Event Street",
      addressLocality: "San Diego",
      addressRegion: "CA",
      postalCode: "92101",
      addressCountry: "US"
    },
    openingHoursSpecification: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday"
      ],
      opens: "09:00",
      closes: "17:00",
      timeZone: "America/Los_Angeles"
    },
    description: "Ready to amplify your events? Reach out to RSVPPASS for partnerships, event discovery, or digital marketing solutions."
  },
  about: [
    {
      "@type": "Thing",
      name: "Partnership Opportunities",
      description: "Join our 300+ partner network, including Ultra Miami and Caesars Palace."
    },
    {
      "@type": "Thing",
      name: "Event Exposure",
      description: "Reach 1M+ contacts through our app and marketing channels."
    },
    {
      "@type": "Thing",
      name: "Expert Support",
      description: "20+ years of event marketing expertise at your service."
    }
  ]
};


const ContactMain = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [status, setStatus] = useState(null); // 'loading', 'success', 'error'
  const [errorMessage, setErrorMessage] = useState('');

  // Update form state on input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    setStatus('loading');
    setErrorMessage('');

    // Basic validation example
    if (
      !formData.email ||
      !formData.name ||
      !formData.message
    ) {
      setErrorMessage('Please fill in all required fields.');
      setStatus('error');
      return;
    }

    const postData = {
      name: formData.name,
      to: formData.email,
      subject: `RSVP Events contact from ${formData.name}`,
      content: `
        <html>
          <body>
            <h2>New Contact Message</h2>
            <p><strong>Name:</strong> ${formData.name}</p>
            <p><strong>Email:</strong> ${formData.email}</p>
            <p><strong>Message:</strong></p>
            <p style="white-space: pre-line;">${formData.message}</p>
          </body>
        </html>
      `,
    };


    try {
      const response = await fetch(`${wpUrl}wp-json/myplugin/v1/send-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(postData),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setStatus('success');
        setFormData({
          name: '',
          email: '',
          message: '',
        });
      } else {
        setErrorMessage(data.error || 'Failed to send message.');
        setStatus('error');
      }
    } catch (error) {
      setErrorMessage(error.message || 'Something went wrong.');
      setStatus('error');
    }
  };
    
  return (
    <>
    
        {typeof window !== "undefined" && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
          
        />
      )}
      
     
      <section className="contact-one">
        <div className="container">
          <div className="contact-one__inner">
            <h3 className="contact-one__title">Connect with Our Team</h3>
            <p className="contact-one__text">
              Ready to amplify your events? Reach out to RSVPPASS for partnerships, event discovery, or digital marketing solutions.
            </p>
            <p className="contact-one__text">Fill out the form or use our contact details below. We respond within 24-48 hours.</p>
            <form className="contact-one__form" onSubmit={handleSubmit} noValidate>
              <div className="row">
                <div className="col-xl-6 col-lg-6">
                  <div className="contact-one__input-box">
                    <input
                      type="text"
                      name="name"
                      placeholder="Your Name"
                      required
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div className="contact-one__input-box">
                    <input
                      type="email"
                      name="email"
                      placeholder="Your Email"
                      required
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                
                <div className="col-xl-12">
                  <div className="contact-one__input-box text-message-box">
                    <textarea
                      name="message"
                      placeholder="Your Message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>
                  <div className="contact-one__btn-box">
                    <button
                      type="submit"
                      className="thm-btn contact-one__btn"
                      disabled={status === 'loading'}
                    >
                      {status === 'loading' ? 'Sending...' : 'Submit Now'}
                      <span className="icon-arrow-right"></span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <div className="result">
              {status === 'success' && <p className="success-msg">Message sent successfully!</p>}
              {status === 'error' && <p className="error-msg">{errorMessage}</p>}
            </div>
          </div>
        </div>
      </section>

       <section className="contact-two">
          <div className="container">
            <div className="row">
              {/* Contact Two Single Start */}
              <div className="col-xl-3 col-lg-3">
                <div className="contact-two__single">
                  <div className="contact-two__icon">
                    <span className="icon-pin"></span>
                  </div>
                  <h3 className="contact-two__title">Location</h3>
                  <p className="contact-two__text">
                    123 Event Street, San Diego, CA 92101, USA
                  </p>
                </div>
              </div>
              {/* Contact Two Single End */}

              {/* Contact Two Single Start */}
              <div className="col-xl-3 col-lg-3">
                <div className="contact-two__single">
                  <div className="contact-two__icon">
                    <span className="icon-paper-plan"></span>
                  </div>
                  <h3 className="contact-two__title">E-mail</h3>
                  <p className="contact-two__text">
                    <Link to="mailto:info@rsvppass.com">
                      info@rsvppass.com
                    </Link>
                  </p>
                 
                </div>
              </div>
              {/* Contact Two Single End */}

              {/* Contact Two Single Start */}
              <div className="col-xl-3 col-lg-3">
                <div className="contact-two__single">
                  <div className="contact-two__icon">
                    <span className="icon-call"></span>
                  </div>
                  <h3 className="contact-two__title">Contact</h3>
                  <p className="contact-two__text">
                    <a href="tel:+16195551234">+1 (619) 555-1234</a>
                  </p>
                  
                </div>
              </div>
              {/* Contact Two Single End */}

              <div className="col-xl-3 col-lg-3">
                <div className="contact-two__single">
                  <div className="contact-two__icon">
                    <span className="icon-clock"></span>
                  </div>
                  <h3 className="contact-two__title">Hours</h3>
                  <p className="contact-two__text">
                    Mon-Fri, 9:00 AM - 5:00 PM (PST)
                  </p>
                  
                </div>
              </div>
            </div>
          </div>
        </section>

          <section className="service-details">
            <div className="container">
              <div className="service-details__top">
                <div className="row">
                  <h2 className="section-title__title">Why Contact Us?
                  </h2>
                  <p className="text-center">Let's create unforgettable events. Partner with RSVPPASS to reach millions and elevate your events.</p>
                </div>
              </div>
              <div className="service-details__bottom">
                <div className="row">
                  {/* Services Details */}
                  {serviceDetails.servicecard.map((item, index) => (
                    <div key={index} className="col-xl-4 col-lg-4">
                      <div className="service-details__single">
                        <div className="service-details__icon">
                          <span className="icon-theater"></span>
                        </div>
                        <h3 className="service-details__title">
                          {item.question}
                        </h3>
                        <p className="service-details__text">{item.answer}</p>
                        
                      </div>
                    </div>
                  ))}
                </div>
               
               
              </div>
            </div>
          </section>
    </>
  );
};

export default ContactMain;
